import NavLink from 'components/NavLink';
import config from 'config';

export const isInternalHref = (href) => config.appUrlRegex && !!href?.match(config.appUrlRegex);

export const toInternalPath = (href) => {
  if (!isInternalHref(href)) {
    return null;
  }

  const { pathname, search } = new URL(href);

  return `${pathname}${search}`;
};

export const seeMoreProps = (url) => {
  if (!url) {
    return undefined;
  }

  const path = toInternalPath(url);

  return path ? { component: NavLink, to: path } : { component: 'a', href: url };
};
